export const getters = {
  getCourses: (state) => {
    return state.courses
  },
  isLoadingCourses: (state) => {
    return state.loadingCourses
  },
}
